<div class="container clearfix">
  <!-- 検索欄 -->
  <div class="search-section" *ngIf="searchParams" [ngClass]="{'close-search-section': closeSearch}">
    <app-auto-matching-search-section (searching)="loadingStart()" (searchFinish)="loadingFinish()"
      [autoSearchConditionGroup]="searchParams">
    </app-auto-matching-search-section>
  </div>

  <app-search-section-toggle [(closeStatus)]="closeSearch"></app-search-section-toggle>

  <div class="list-section" infiniteScroll [infiniteScrollDistance]="1.5" [infiniteScrollThrottle]="150"
    [infiniteScrollDisabled]="loading" [scrollWindow]="false" (scrolled)="pageLoad()">
    <div class="row" *ngIf="alreadyRead">
      <div class="col-md-6">
        <div class="header">
          案件一覧
        </div>
      </div>
      <div class="col-md-6">
        <div class="header">
          人材一覧
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div *ngIf="alreadyRead; else elseContent">
          <ng-container *ngFor="let result of results; let i = index">
            <div class="row position-relative card_wrapper" [class.link_list_hover_white]="openCard[i] ? null : true"
              *ngIf="!result.matching.is_pair_already_offered"
              [@dislike]="IsDislikePair(result.worker_mail.ai_mail_id, result.project_mail.ai_mail_id)"
              (@dislike.done)="dislikeDoneEvent(result.worker_mail, result.project_mail.ai_mail_id,i, $event)">

              <!-- ここから下は、案件 -->
              <div class="card col-md-6">
                <!-- [NOTE] おすすめ画面では[offeredMailIds]をapp-cardに渡していない模様。
                  案件・人材のペアどちらかでも提案済みの場合おすすめに表示しない仕様のためこのままとしているが
                　仕様が変わったら、おすすめ画面に「提」アイコンを表示するにはここにパラメータの付与が必要となる認識 -->
                <app-card [mailInfo]="result.project_mail" [pairMail]="result.worker_mail" [mailType]="'project'"
                  [result]="result" [page]="page"
                  [baseKeywords] ="getKeys(result.worker_mail.keywords)"
                  [clickableArea]="1"
                  [searchParams]="searchParamsProject" [displayStatus]="openCard[i] ? 3 : 1"
                  (deleted)="onDeleted(i, 'project')" (click_card)="clickCard(i)">
                </app-card>

              </div>
              <!-- ここから下は、人材 -->
              <div class="card col-md-6">
                <!-- [NOTE] おすすめ画面では[offeredMailIds]をapp-cardに渡していない模様。
                  案件・人材のペアどちらかでも提案済みの場合おすすめに表示しない仕様のためこのままとしているが
                　仕様が変わったら、おすすめ画面に「提」アイコンを表示するにはここにパラメータの付与が必要となる認識 -->
                <app-card [mailInfo]="result.worker_mail" [pairMail]="result.project_mail" [mailType]="'worker'"
                  [result]="result" [page]="page"
                  [baseKeywords] ="getKeys(result.project_mail.keywords)"
                  [clickableArea]="1"
                  [searchParams]="searchParamsWorker" [displayStatus]="openCard[i] ? 3 : 1" (deleted)="onDeleted(i, 'worker')"
                  (click_card)="clickCard(i)">
                </app-card>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="loading">
            <div class="loader"></div>
            <div class="text-center">計算中...</div>
          </ng-container>

          <button *ngIf="!loading && results.length > 0" class="btn btn-primary-dark border-0 btn-more " type="button" (click)="pageLoad()">
            <i class="fa fa-chevron-down margin-right-5"></i>更に検索
          </button>
        </div>
      </div>
    </div>

    <div class="space"></div>
    <!-- ローディングアニメーション -->
    <ng-template #elseContent>
      <div class="loader"></div>
      <div class="text-center">計算中...</div>
    </ng-template>
  </div>
</div>
<app-footer></app-footer>